import { useRef } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { NSBoxString, NSBoxEntity, NSBox } from 'namirasoft-site-react';
import { AccountEntities } from "../AccountEntities";
import { UserRow } from "namirasoft-account";
import { SortItem } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

interface ServiceSessionEditPageProps extends NSARouterMakerResult, AccountRouterProps
{
	isEdit: boolean;
}

function ServiceSessionEditPage(props: ServiceSessionEditPageProps) 
{
	const NSBoxString_Name = useRef<NSBoxString>(null);
	const NSBoxEntity_User = useRef<NSBoxEntity<UserRow>>(null);

	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<AccountLayout {...props}
			action={{
				title: (props.isEdit ? "Edit" : "New") + ' Service Session',
				description: '',
				menus: {}
			}}
			pages={{
				entity: AccountEntities.service_session(props),
				ui: {},
				edit: {
					...props,
					ui: {
						tab_page_edit: {
							editor: {
								getInputRow: () =>
								{
									let user_id: string = NSBoxEntity_User.current?.getValueOne() ?? "";
									let name: string = NSBoxString_Name.current?.getValue() ?? "";
									return {
										user_id,
										name,
										session_category: [],
										session_field: [],
										session_tag: [],
									};
								},
								setRow: (row) =>
								{
									NSBoxEntity_User.current?.setValue(row.id)
									NSBoxString_Name.current?.setValue(row.name || "");
								}
							}
						}
					}
				}
			}}
		>
			<>
			<NSBoxString
				ref={NSBoxString_Name}
				title="Name"
				required={true}
				style={{ width: NSBox.width.double }}
				info={{ link: "https://namirasoft.com/account/console-guide/service-session/#field-name" }}
			/>
			<NSBoxEntity<UserRow>
				ref={NSBoxEntity_User}
				title="Service User"
				required
				multiple={false}
				list={() => props.account.server.service_user.List([], 1, 1000, [], null)}
				table_name={namirasoft.account.tables.user.name}
				getTitle={(item) => item.first_name}
				getValue={item => item.id}
				getSort={() =>
				{
					let table = namirasoft.account.tables.user;
					let column = table.columns.first_name;
					return new SortItem(table, column, true);
				}}
				style={{ width: NSBox.width.double }}
				info={{ link: "https://namirasoft.com/account/console-guide/service-session/#field-service-user" }}
			/>
			</>
		</AccountLayout>
	);
}
export default ServiceSessionEditPage;